import axios from '../../plugins/FinanceiroInterceptor'

export const actions = {
    listarErros(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`erros` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    reprocessarErros(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/mensalidades/descontos', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/erros_financeiro.js